import { Link } from 'react-router-dom';
import { articleLinks } from '@/mocks/seoData';

export default function ArticleSection() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-xl sm:text-2xl md:text-3xl font-heading font-medium md:font-semibold text-foreground-900 mb-3">
            <strong>Sugargoo Spreadsheet</strong> Knowledge Base
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            Explore our in-depth guides and articles about <strong>Sugargoo Spreadsheet</strong> resources,
            tips, and best practices for international shoppers. New articles added regularly.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {articleLinks.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-200 cursor-pointer"
            >
              <div className="aspect-[16/9] overflow-hidden bg-background-200">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <h3 className="text-sm font-heading font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors leading-snug">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-600 leading-relaxed line-clamp-2">
                  {article.description}
                </p>
                <div className="mt-3 flex items-center text-xs text-primary-600 font-medium">
                  Read Article
                  <i className="ri-arrow-right-line ml-1 group-hover:translate-x-0.5 transition-transform"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}